module.exports = __webpack_public_path__ + "img/CRM.17496b96.png";